// @flow

// #region imports
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'shared/routing/withRouter';
import ErrorDialogBox from '../../../components/Common/dialogContainer';
import SuccessReedomModel from '../../../components/Common/sucessfulModel';
import { bindActionCreators } from 'redux';
import { getReedemCode, submitReedemCode } from '../action';
import logo from '../../../assets/lockic_200px.png';
import { Divider } from '@react-md/divider';
import goldIcon from '../../../assets/ic_goldstart.png';
import platIcon from '../../../assets/ic_partner.png';
import placeHolder from '../../../assets/gallery_place_holder.png';
import storeGroupIcon from '../../../assets/storeIcon.png';
import onlOffGroupIcon from '../../../assets/web_hi_res_512.png';
import { decodeBase64 } from '../../../components/Common/Tool';

import queryString from 'query-string';

// #endregion
class QRScanner extends React.Component {
  constructor(props) {
    super(props);
    const { location } = this.props;
    const url = queryString.parse(location.search);
    const parsed = decodeBase64(url.url);
    this.state = {
      GroupCode: parsed.GroupCode,
      GroupName: parsed.GroupName,
      ImagePath: parsed.ImagePath,
      ProductName: parsed.ProductName,
      SegmentCode: parsed.SegmentCode,
      SupplierName: parsed.SupplierName,
      OrderKey: parsed.OrderKey,
      code: '',
      isErrorDialogVisible: false,
      isKeyboardOpen: false,
    };
  }

  componentDidMount() {
    var setModel = {
      ValidatorKey: this.props.qrCode,
      UserKey: this.props.uid,
      Key: this.state.OrderKey,
    };
    const p = this.props.getReedemCode(setModel);
    if (p != null && typeof p.then === 'function') {
      p.catch(() => {});
    }
  }
  handleChangeReedemCode(event) {
    // window.addEventListener("resize", (e) => {
    //   this.setState({isKeyboardDetected:true})
    // });
    this.setState({
      code: event.target.value.slice(0, 6),
    });
  }
  onSubmitRedeemCode() {
    // window.addEventListener("resize", (e) => {
    //   this.setState({isKeyboardDetected:false})
    // });
    if (this.state.code !== '') {
      var setModel = {
        ValidatorKey: this.props.qrCode,
        UserKey: this.props.uid,
        Key: this.state.OrderKey,
        RedeemCode: this.state.code,
      };

      this.props
        .submitReedemCode(setModel)
        .then((resp) => {
          if (resp.value.data.Status == 1) {
            window.location.href = '/successTransaction';
          } else {
            this.setState({
              code: '',
              errMsg: 'Please enter valid code ',
              isErrorDialogVisible: true,
            });
          }
        })
        .catch((err) => {
          this.setState({
            errMsg: 'Entered Code is not valid',
            isErrorDialogVisible: true,
          });
        });
    } else {
      this.setState({
        errMsg: 'Please enter code',
        isErrorDialogVisible: true,
      });
    }
  }
  closeDialog() {
    this.setState({
      errMsg: '',
      isErrorDialogVisible: false,
    });
  }
  onFocusHandler = () => {
    this.setState({
      isKeyboardOpen: true,
    });
  };
  onBlurHandler = () => {
    this.setState({
      isKeyboardOpen: false,
    });
  };

  render() {
    var Icon = null;
    const {
      ImagePath,
      GroupCode,
      GroupName,
      ProductName,
      SegmentCode,
      SupplierName,
    } = this.state;
    if (SegmentCode === 'PLAT') {
      Icon = platIcon;
    } else if (SegmentCode === 'GOLD') {
      Icon = goldIcon;
    } else {
      Icon = null;
    }
    return (
      <div className="card Card-container card-pd-B">
        <div
          className="row Mb-3 Mb-B10"
          style={{ height: this.state.isKeyboardOpen ? '130vh' : '100vh' }}>
          <div className="col-sm-12 col-md-12 col-lg-12">
            <div className="">
              <div className="card-body no-Pd org-width-image">
                {ImagePath !== '' && ImagePath !== null ? (
                  <img
                    src={ImagePath}
                    style={{
                      width: '100%',
                      height: '100%',
                      minHeight: '20vh',
                      maxHeight: '30vh',
                    }}
                  />
                ) : (
                  <img
                    src={placeHolder}
                    style={{ height: 200 }}
                    className="couponImg"
                  />
                )}
              </div>
              <div className="card-Pd">
                <h5 className="card-title">{ProductName}</h5>
                <span className="card-text F5 Mr-R">
                  {Icon !== null ? (
                    <img src={Icon} className="segmentIcon" />
                  ) : null}
                  {SupplierName}
                </span>
                <span className="card-text F5">
                  {GroupCode == 'ONLOFF' ? (
                    <img
                      src={storeGroupIcon}
                      style={{ height: 13 }}
                      className="segmentIcon"
                    />
                  ) : (
                    <img
                      src={onlOffGroupIcon}
                      style={{ height: 13 }}
                      className="segmentIcon"
                    />
                  )}
                  {GroupName}
                </span>
              </div>

              <Divider />

              <div style={{ textAlign: 'center', padding: '25px 65px' }}>
                <div className="reedem-code-align">Enter Code</div>
                <div className="code-text-info">
                  Code sent to your email and SMS
                </div>
                <div>
                  <input
                    type="text"
                    className={'borderEffectCode'}
                    name="Code "
                    max="6"
                    onFocus={this.onFocusHandler}
                    onBlur={this.onBlurHandler}
                    autoFocus={false}
                    maxLength="6"
                    value={this.state.code}
                    onChange={this.handleChangeReedemCode.bind(this)}
                  />
                </div>
                <div
                  className="btn btn-primary btn-align-submit"
                  onClick={this.onSubmitRedeemCode.bind(this)}>
                  SUBMIT
                </div>
              </div>
            </div>
          </div>
        </div>
        <ErrorDialogBox
          errorMsg={this.state.errMsg}
          isErrorDialogVisible={this.state.isErrorDialogVisible}
          closeDialog={this.closeDialog.bind(this)}
        />
      </div>
    );
  }
}
// #region redux map state and dispatch to props
const mapStateToProps = (state) => {
  return {
    qrCode: state.reward.qrCode,
    uid: state.reward.uid,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getReedemCode,
      submitReedemCode,
    },
    dispatch
  );
};

// #endregion
export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(QRScanner);
